// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Bet Slip Container */
.sportsbook-bet-slip-container {
  width: 100%;
  max-width: 959px;
  z-index: 1;
}

@media (max-width: 959px) {
  .sportsbook-bet-slip-container {
    position: fixed !important;
    bottom: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    z-index: 1000;
  }
}
@media (min-width: 960px) {
  .sportsbook-bet-slip-container {
    width: 375px;
    position: fixed;
    margin-top: 10px;
  }
}
.sportsbook-bet-slip-mobile-transparent-overlay {
  position: absolute; /* Position it absolutely within the container */
  top: 0; /* Start at the top */
  left: 0; /* Start at the left */
  width: 100%; /* Full width */
  min-height: 150px; /* Minimum height to avoid the rest raising too high */
  height: calc(100% - 150px); /* Fill remaining height */
  background-color: transparent; /* Fully transparent */
  z-index: 1000; /* Ensures it is above other elements */
}

.sportsbook-bet-slip-header {
  width: 100%;
  height: 40px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-color: #f0f0f0;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border: 1px solid #002129;
}
@media (min-width: 960px) {
  .sportsbook-bet-slip-header {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
}

.sportsbook-bet-slip-left-info {
  display: flex;
  align-items: center;
}

.sportsbook-bet-slip-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #00aad1;
  border-radius: 50%;
  margin-right: 8px;
}

.sportsbook-bet-slip-circle-text {
  color: #fff;
  font-size: 14px;
  font-weight: 700 !important;
}

.sportsbook-bet-slip-text {
  color: #002129;
  font-family: "Inter", sans-serif !important;
  font-feature-settings: "liga" off, "clig" off;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 26px;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  font-size: 12px;
}
@media (min-width: 600px) {
  .sportsbook-bet-slip-text {
    font-size: 14px;
  }
}

.sportsbook-bet-slip-mobile-button {
  display: flex;
  align-items: center;
  color: #002129;
  font-family: "Inter", sans-serif;
  font-feature-settings: "liga" off, "clig" off;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  font-size: 12px;
}
@media (min-width: 600px) {
  .sportsbook-bet-slip-mobile-button {
    font-size: 14px;
  }
}

.sportsbook-bet-slip-mobile-toggle-icon {
  margin-left: 6px;
  transition: transform 0.1s ease-in-out;
}
.sportsbook-bet-slip-mobile-toggle-icon.open {
  transform: rotate(0deg);
}
.sportsbook-bet-slip-mobile-toggle-icon:not(.open) {
  transform: rotate(180deg);
}

.sportsbook-bet-type-bar {
  width: 100%;
  height: 40px;
  background-color: #002129;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.sportsbook-bet-type-container {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #002129;
  height: 100%;
  padding: 0;
}
.sportsbook-bet-type-container.active {
  background-color: #002F3A;
}

.sportsbook-bet-type-text {
  color: #fff;
  font-family: "Inter", sans-serif !important;
  font-feature-settings: "liga" off, "clig" off;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 26px;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  font-size: 12px;
  padding: 0;
  margin: 0;
}
@media (min-width: 600px) {
  .sportsbook-bet-type-text {
    font-size: 14px;
  }
}
.sportsbook-bet-type-text.active {
  color: #ffc60a;
  background-color: #002F3A;
}

.sportsbook-what-is-a-bet-bar {
  width: 100%;
  height: 34px;
  background-color: #fff;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
}

.sportsbook-what-is-a-bet-container {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.sportsbook-what-is-a-bet-text {
  color: #00AAD1;
  text-decoration: underline;
  font-family: "Inter", sans-serif;
  font-feature-settings: "liga" off, "clig" off;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 26px;
  letter-spacing: 0.46px;
  font-size: 12px !important;
}
@media (min-width: 600px) {
  .sportsbook-what-is-a-bet-text {
    font-size: 14px;
  }
}

.sportsbook-what-is-a-bet-info-icon {
  color: #00AAD1;
  margin-left: 8px;
}

.scrollable-bet-container {
  max-height: 400px; /* Set max height to 370px */
  background-color: #fff; /* White background */
  overflow-y: auto; /* Enable vertical scrolling when content exceeds the max height */
}

.sportsbook-staight-bet-container {
  width: 100%;
  height: auto;
  min-width: 121px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #002129;
  background-color: #fff;
}

.sportsbook-game-info-container {
  display: flex;
  justify-content: space-between; /* Pushes the left and right content to opposite sides */
  align-items: center;
  width: 100%;
  margin: 0px 0px;
  height: 35px;
  margin-top: 11px;
  margin-bottom: 8px;
}

.sportsbook-game-info-left-side {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  margin-left: 10px;
}
.sportsbook-game-info-left-side svg {
  width: 18px;
  height: 18px;
  fill: #CC293C;
}

.sportsbook-game-info-left-text {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}

.sportsbook-game-info-big-text {
  color: #002129;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 1 !important;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  text-align: left;
}

.sportsbook-game-info-big-text-right {
  color: #002129;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 1 !important;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  text-align: right;
}

.sportsbook-game-info-small-text {
  color: #002129;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 1 !important;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  text-align: left;
}

.sportsbook-game-info-small-text-right {
  color: #002129;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 1 !important;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  text-align: right;
  margin-top: 10px !important;
}

.sportsbook-game-info-right-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 10px;
}

.sportsbook-game-info-right-text {
  text-align: right;
}

.spacer {
  height: 16px;
}

.sportsbook-wager-boxes-container {
  width: 100%;
  margin: 0px 19px;
  height: 40px;
  margin-bottom: 11px;
  display: flex;
  justify-content: center;
  gap: 28px; /* Default gap for small screens */
}

/* Medium screens (md) */
@media (min-width: 600px) {
  .sportsbook-wager-boxes-container {
    gap: 80px;
  }
}
/* Large screens (lg) and up */
@media (min-width: 960px) {
  .sportsbook-wager-boxes-container {
    gap: 50px;
  }
}
.sportsbook-wager-box {
  width: 150px;
  height: 40px;
  border: 1px solid #002129;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.sportsbook-wager-box.sportsbook-wager-box-exceeded {
  border-color: #CC293C;
}

.sportsbook-wager-box-label {
  color: #002129;
  font-size: 10px !important;
  font-weight: 500 !important;
  text-align: left;
  margin-left: 5px !important;
}
.sportsbook-wager-box-label.sportsbook-wager-box-label-exceeded {
  color: #CC293C;
}

.sportsbook-wager-currency {
  color: #002129;
  font-size: 16px !important;
  font-weight: 700 !important;
  margin-left: 5px !important;
  line-height: normal;
  padding: 0;
  display: flex;
  align-items: center;
}

.sportsbook-wager-input input {
  text-align: left;
  font-size: 16px;
  color: #002129;
  padding: 0 2px;
  margin-left: 5px;
}
.sportsbook-wager-input fieldset {
  border: none;
}
.sportsbook-wager-input .MuiOutlinedInput-root {
  padding: 0;
  height: 100%;
}

.sportsbook-remove-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: 1px solid #002129;
  background-color: #fff;
}

.sportsbook-remove-icon {
  cursor: pointer;
}

.sportsbook-remove-text {
  color: #CC293C;
  font-weight: 700 !important;
  margin-left: 16px !important;
  cursor: pointer;
  font-size: 14px !important;
}

.sportsbook-parlay-teaser-box {
  width: 100%;
  height: 43px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 8px;
  background-color: #fff;
}
.sportsbook-parlay-teaser-box .sportsbook-parlay-teaser-line1, .sportsbook-parlay-teaser-box .sportsbook-parlay-teaser-line2 {
  color: #002129;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-style: normal;
  text-transform: capitalize;
  letter-spacing: 0.46px;
}
.sportsbook-parlay-teaser-box .sportsbook-parlay-teaser-line1 {
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 22px; /* 183.333% */
}
.sportsbook-parlay-teaser-box .sportsbook-parlay-teaser-line2 {
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 22px;
}

.sportsbook-submit-button-container {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
  border-bottom: 1px solid #002129;
  background-color: #fff;
}

.sportsbook-submit-button {
  width: 300px;
  height: 42px;
  border: none;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.12);
}
.sportsbook-submit-button:hover {
  background-color: currentColor;
  color: currentColor;
}
.sportsbook-submit-button.active {
  background-color: #00AAD1;
}
.sportsbook-submit-button.active:hover {
  background-color: #00AAD1;
}
.sportsbook-submit-button.inactive {
  background-color: rgba(0, 0, 0, 0.12);
}
.sportsbook-submit-button.inactive:hover {
  background-color: rgba(0, 0, 0, 0.12);
}

.sportsbook-submit-button-text-top {
  color: var(--primary-contrast, #FFF);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 13px; /* 65% */
  letter-spacing: 0.46px;
  text-transform: uppercase;
  text-align: center;
  margin-top: 2px;
  white-space: nowrap;
}
.inactive .sportsbook-submit-button-text-top {
  color: rgba(0, 0, 0, 0.38);
}

.sportsbook-submit-button-text-bottom {
  color: var(--primary-contrast, #FFF);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 13px;
  letter-spacing: 0.46px;
  text-transform: uppercase;
  text-align: center;
}
.inactive .sportsbook-submit-button-text-bottom {
  color: rgba(0, 0, 0, 0.38);
}

.sportsbook-bet-unavailable-container {
  width: 100%; /* 100% width */
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
  border-bottom: 1px solid #002129;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px; /* Optional: Add some padding for spacing */
}

.sportsbook-bet-unavailable-title {
  color: #002129;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 26px; /* 162.5% */
  letter-spacing: 0.46px;
  margin-bottom: 32px !important; /* Optional: Add some margin between the title and the next line */
}

.sportsbook-bet-unavailable-subtitle,
.sportsbook-bet-unavailable-description {
  color: #002129;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 26px; /* 185.714% */
  letter-spacing: 0.46px;
  margin-bottom: 24px !important; /* Optional: Add some margin between lines */
  max-width: 300px;
  text-align: center;
}

.custom-dialog-paper {
  width: 341px !important; /* Custom width */
  margin: 0px !important; /* Remove default margin */
}

/* Dialog Header Styling */
.dialog-title {
  color: #000;
  text-align: center;
  font-family: Inter, sans-serif !important;
  font-size: 16px !important;
  font-weight: 800 !important;
  line-height: 24px; /* 150% of 16px */
  letter-spacing: -0.304px;
}

/* Dialog Content Styling */
.dialog-content {
  color: #000;
  text-align: center;
  font-family: Inter, sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 24px; /* 150% of 16px */
  letter-spacing: -0.304px;
  white-space: pre-line; /* Preserves line breaks */
  width: 100% !important; /* Custom width */
  padding: 10px 16px !important; /* Custom padding */
}

/* Center the Dialog Actions and style the button */
.dialog-actions {
  display: flex;
  justify-content: center !important;
  padding: 16px !important;
}
.dialog-actions .dialog-close-button {
  color: #fff;
  background-color: #00AAD1; /* Primary blue color */
}
.dialog-actions .dialog-close-button:hover {
  background-color: #00AAD1; /* Darker shade of blue on hover */
}

/* BetSlip.scss */
.picks-container {
  max-height: 225px;
  overflow-y: auto; /* Enable vertical scrolling */
  width: 100%; /* Ensure it takes up the full width of the parent */
  box-sizing: border-box; /* Make sure the border is included in the width calculation */
  margin: 0; /* Remove any default margin */
}`, "",{"version":3,"sources":["webpack://./src/components/SportsbookComponents/BetSlip/BetSlip.scss"],"names":[],"mappings":"AAAA,4BAAA;AACA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAEA;EACE;IACE,0BAAA;IACA,oBAAA;IACA,sBAAA;IACA,oBAAA;IACA,aAAA;EACF;AACF;AAEA;EACE;IACE,YAAA;IACA,eAAA;IACA,gBAAA;EAAF;AACF;AAKA;EACE,kBAAA,EAAA,gDAAA;EACA,MAAA,EAAA,qBAAA;EACA,OAAA,EAAA,sBAAA;EACA,WAAA,EAAA,eAAA;EACA,iBAAA,EAAA,sDAAA;EACA,0BAAA,EAAA,0BAAA;EACA,6BAAA,EAAA,sBAAA;EACA,aAAA,EAAA,uCAAA;AAHF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,yBAAA;AALF;AAQE;EAdF;IAeM,2BAAA;IACA,4BAAA;EALJ;AACF;;AASE;EACE,aAAA;EACA,mBAAA;AANJ;;AASE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AANJ;;AASE;EACE,WAAA;EACA,eAAA;EACA,2BAAA;AANJ;;AASE;EACE,cAAA;EACA,2CAAA;EACA,6CAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;AANJ;AAQI;EAXF;IAYI,eAAA;EALJ;AACF;;AAQE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;AALJ;AAOI;EAbF;IAcI,eAAA;EAJJ;AACF;;AAOE;EACE,gBAAA;EACA,sCAAA;AAJJ;AAMI;EACE,uBAAA;AAJN;AAOI;EACE,yBAAA;AALN;;AAWA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AARJ;;AAWE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;AARJ;AAUI;EACE,yBAAA;AARN;;AAYE;EACE,WAAA;EACA,2CAAA;EACA,6CAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AATJ;AAWI;EAbF;IAcI,eAAA;EARJ;AACF;AAUI;EACE,cAAA;EACA,yBAAA;AARN;;AAcE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,8BAAA;AAXJ;;AAcE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAXJ;;AAcE;EACE,cAAA;EACA,0BAAA;EACA,gCAAA;EACA,6CAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;AAXJ;AAaI;EAXF;IAYI,eAAA;EAVJ;AACF;;AAaE;EACE,cAAA;EACA,gBAAA;AAVJ;;AAeE;EACE,iBAAA,EAAA,4BAAA;EACA,sBAAA,EAAA,qBAAA;EACA,gBAAA,EAAA,kEAAA;AAZJ;;AAiBE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;AAdJ;;AAiBE;EACE,aAAA;EACA,8BAAA,EAAA,wDAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAdJ;;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;AAdJ;AAgBI;EACI,WAAA;EACA,YAAA;EACA,aAAA;AAdR;;AAkBA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AAfJ;;AAkBE;EACE,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;AAfJ;;AAkBA;EACI,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,iBAAA;AAfJ;;AAkBA;EACI,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;AAfJ;;AAkBA;EACI,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,iBAAA;EACA,2BAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AAfJ;;AAkBA;EACI,iBAAA;AAfJ;;AAmBA;EACI,YAAA;AAhBJ;;AAqBA;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA,EAAA,kCAAA;AAlBJ;;AAqBE,wBAAA;AACA;EACE;IACE,SAAA;EAlBJ;AACF;AAqBE,8BAAA;AACA;EACE;IACE,SAAA;EAnBJ;AACF;AAuBE;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AArBJ;AAuBI;EACE,qBAAA;AArBN;;AAyBE;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,2BAAA;AAtBJ;AAwBI;EACE,cAAA;AAtBN;;AA2BE;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AAxBJ;;AA4BI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAzBN;AA2BI;EACE,YAAA;AAzBN;AA2BI;EACE,UAAA;EACA,YAAA;AAzBN;;AA+BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;AA5BJ;;AA+BE;EACE,eAAA;AA5BJ;;AA+BE;EACE,cAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,0BAAA;AA5BJ;;AAiCE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AA9BJ;AAgCI;EACE,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,kBAAA;EACA,0BAAA;EACA,sBAAA;AA9BN;AAiCI;EACE,0BAAA;EACA,2BAAA;EACA,iBAAA,EAAA,aAAA;AA/BN;AAkCI;EACE,0BAAA;EACA,2BAAA;EACA,iBAAA;AAhCN;;AAsCI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;AAnCR;;AAsCM;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,qCAAA;AAnCR;AAsCQ;EACI,8BAAA;EACA,mBAAA;AApCZ;AAuCQ;EACE,yBAAA;AArCV;AAuCU;EACE,yBAAA;AArCZ;AAyCQ;EACE,qCAAA;AAvCV;AAyCU;EACE,qCAAA;AAvCZ;;AA4CM;EACE,oCAAA;EACA,6CAAA;EACA,gCAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA,EAAA,QAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAzCR;AA2CQ;EACE,0BAAA;AAzCV;;AA6CM;EACE,oCAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AA1CR;AA4CQ;EACE,0BAAA;AA1CV;;AAgDM;EACE,WAAA,EAAA,eAAA;EACA,+BAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA,EAAA,2CAAA;AA7CR;;AAgDM;EACE,cAAA;EACA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA,EAAA,WAAA;EACA,sBAAA;EACA,8BAAA,EAAA,kEAAA;AA7CR;;AAgDM;;EAEE,cAAA;EAEA,6CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,8BAAA,EAAA,4CAAA;EACA,gBAAA;EACA,kBAAA;AA7CR;;AAkDM;EACE,uBAAA,EAAA,iBAAA;EACA,sBAAA,EAAA,0BAAA;AA/CR;;AAmDM,0BAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,0BAAA;EACA,2BAAA;EACA,iBAAA,EAAA,iBAAA;EACA,wBAAA;AAhDR;;AAmDM,2BAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,0BAAA;EACA,2BAAA;EACA,iBAAA,EAAA,iBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,0BAAA;EACA,sBAAA,EAAA,iBAAA;EACA,6BAAA,EAAA,mBAAA;AAhDR;;AAmDM,mDAAA;AACA;EACE,aAAA;EACA,kCAAA;EACA,wBAAA;AAhDR;AAkDQ;EACI,WAAA;EACA,yBAAA,EAAA,uBAAA;AAhDZ;AAiDY;EACI,yBAAA,EAAA,kCAAA;AA/ChB;;AAsDM,iBAAA;AAEA;EACE,iBAAA;EACA,gBAAA,EAAA,8BAAA;EACA,WAAA,EAAA,oDAAA;EACA,sBAAA,EAAA,8DAAA;EACA,SAAA,EAAA,8BAAA;AApDR","sourcesContent":["/* Main Bet Slip Container */\n.sportsbook-bet-slip-container {\n  width: 100%;\n  max-width: 959px;\n  z-index: 1;\n}\n\n@media (max-width: 959px) {\n  .sportsbook-bet-slip-container {\n    position: fixed !important;\n    bottom: 0 !important;\n    width: 100% !important;\n    margin: 0 !important;\n    z-index: 1000;\n  }\n}\n\n@media (min-width: 960px) {\n  .sportsbook-bet-slip-container {\n    width: 375px;\n    position: fixed;\n    margin-top: 10px;\n  }\n}\n\n\n//Transparent Overlay for Mobile, so a click above closes bet window\n.sportsbook-bet-slip-mobile-transparent-overlay {\n  position: absolute;       /* Position it absolutely within the container */\n  top: 0;                   /* Start at the top */\n  left: 0;                  /* Start at the left */\n  width: 100%;              /* Full width */\n  min-height: 150px;        /* Minimum height to avoid the rest raising too high */\n  height: calc(100% - 150px); /* Fill remaining height */\n  background-color: transparent; /* Fully transparent */\n  z-index: 1000;            /* Ensures it is above other elements */\n}\n\n\n// Bet Slip Header\n.sportsbook-bet-slip-header {\n  width: 100%;                     // Full width\n  height: 40px;                    // Fixed height 40px\n  border-top-left-radius: 4px;     // Top left corner radius\n  border-top-right-radius: 4px;    // Top right corner radius\n  background-color: #f0f0f0;       // Background color\n  margin: 0 auto;                  // Center the box horizontally\n  display: flex;                   // Flexbox to align items\n  align-items: center;             // Vertically center items\n  justify-content: space-between;  // Space between the left and right sections\n  padding: 0 16px;                 // Padding on the left and right\n  border: 1px solid #002129;\n\n  // Media query for 960px and higher\n  @media (min-width: 960px) {\n      border-top-left-radius: 0px;     // Remove top left corner radius\n      border-top-right-radius: 0px;    // Remove top right corner radius\n  }\n}\n\n  \n  .sportsbook-bet-slip-left-info {\n    display: flex;\n    align-items: center;            // Align items vertically\n  }\n  \n  .sportsbook-bet-slip-circle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    background-color: #00aad1;      // Blue background for the circle\n    border-radius: 50%;             // Makes the box a circle\n    margin-right: 8px;              // Space between circle and text\n  }\n  \n  .sportsbook-bet-slip-circle-text {\n    color: #fff;                     // White text color\n    font-size: 14px;\n    font-weight: 700 !important;     // Bold font weight\n  }\n  \n  .sportsbook-bet-slip-text {\n    color: #002129;\n    font-family: 'Inter', sans-serif !important;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: 26px;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    font-size: 12px;                 // Base font size\n  \n    @media (min-width: 600px) {\n      font-size: 14px;               // Larger font size on larger screens\n    }\n  }\n  \n  .sportsbook-bet-slip-mobile-button{\n    display: flex;\n    align-items: center;\n    color: #002129;\n    font-family: 'Inter', sans-serif;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 26px;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    font-size: 12px;                 // Base font size\n  \n    @media (min-width: 600px) {\n      font-size: 14px;               // Larger font size on larger screens\n    }\n  }\n  \n  .sportsbook-bet-slip-mobile-toggle-icon {\n    margin-left: 6px;\n    transition: transform 0.1s ease-in-out;  // Smooth transition\n  \n    &.open {\n      transform: rotate(0deg);  // Rotate icon based on state\n    }\n  \n    &:not(.open) {\n      transform: rotate(180deg);  // Rotate icon based on state\n    }\n  }\n\n\n// Bet Type Bar\n.sportsbook-bet-type-bar {\n    width: 100%;               // Full width\n    height: 40px;              // Fixed height 40px\n    background-color: #002129; // Background color\n    margin: 0 auto;            // Center the box horizontally\n    display: flex;             // Flexbox for alignment\n    align-items: center;       // Vertically center items\n    justify-content: space-around; // Space between the texts\n  }\n  \n  .sportsbook-bet-type-container {\n    flex: 1;                   // Each container takes up one-third of the bar\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;           // Pointer cursor on hover\n    background-color: #002129; // Default background color\n    height: 100%;              // Ensure the container fills the height of the parent\n    padding: 0;                // Remove any padding\n  \n    &.active {\n      background-color: #002F3A; // Active background color\n    }\n  }\n  \n  .sportsbook-bet-type-text {\n    color: #fff;                      // Default text color\n    font-family: 'Inter', sans-serif !important;// Corrected font-family syntax\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-style: normal;\n    font-weight: 700 !important;     // Bold font weight\n    line-height: 26px;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    font-size: 12px;                  // Base font size\n    padding: 0;                       // Ensure no padding\n    margin: 0;                        // Ensure no margin\n  \n    @media (min-width: 600px) {\n      font-size: 14px;                // Larger font size on larger screens\n    }\n  \n    &.active {\n      color: #ffc60a;                 // Active text color\n      background-color: #002F3A;\n    }\n  }\n  \n\n  // What is a Bet Bar\n  .sportsbook-what-is-a-bet-bar {\n    width: 100%;                // Full width\n    height: 34px;               // Fixed height 34px\n    background-color: #fff;     // White background\n    margin: 0 auto;             // Center the box horizontally\n    display: flex;              // Flexbox for alignment\n    align-items: center;        // Vertically center items\n    justify-content: center;    // Horizontally center items\n    border-right: 1px solid #002129; // Right border\n    border-left: 1px solid #002129;  // Left border\n  }\n  \n  .sportsbook-what-is-a-bet-container {\n    cursor: pointer;            // Change cursor to pointer on hover\n    display: flex;              // Flexbox for alignment\n    flex-direction: row;        // Horizontal layout\n    align-items: center;        // Align items vertically\n  }\n  \n  .sportsbook-what-is-a-bet-text {\n    color: #00AAD1;             // Text color\n    text-decoration: underline; // Underline text\n    font-family: 'Inter', sans-serif;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-style: normal;\n    font-weight: 700 !important; // Bold font weight\n    line-height: 26px;\n    letter-spacing: 0.46px;\n    font-size: 12px !important;            // Base font size\n  \n    @media (min-width: 600px) {\n      font-size: 14px;          // Larger font size on larger screens\n    }\n  }\n  \n  .sportsbook-what-is-a-bet-info-icon {\n    color: #00AAD1;             // Icon color\n    margin-left: 8px;           // Space between text and icon\n  }\n  \n\n  // Container for making bets scrollable when a user makes too many bets\n  .scrollable-bet-container {\n    max-height: 400px;  /* Set max height to 370px */\n    background-color: #fff;  /* White background */\n    overflow-y: auto;   /* Enable vertical scrolling when content exceeds the max height */\n  }\n  \n\n  \n  .sportsbook-staight-bet-container {\n    width: 100%;\n    height: auto;\n    min-width: 121px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid #002129;\n    background-color: #fff;\n  }\n  \n  .sportsbook-game-info-container {\n    display: flex;\n    justify-content: space-between;  /* Pushes the left and right content to opposite sides */\n    align-items: center;\n    width: 100%;\n    margin: 0px 0px;\n    height: 35px;\n    margin-top: 11px;\n    margin-bottom: 8px;\n}\n\n  .sportsbook-game-info-left-side {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    height: 100%; // Ensures the inner Box takes the full height of the outer Box\n    margin-left: 10px;\n\n    svg {\n        width: 18px;\n        height: 18px;\n        fill: #CC293C;\n    }\n}\n\n.sportsbook-game-info-left-text {\n    display: flex;\n    flex-direction: column;\n    margin-left: 12px; // Space between the icon and the text\n}\n  \n  .sportsbook-game-info-big-text {\n    color: #002129;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: 1.0 !important;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    text-align: left;\n}\n\n.sportsbook-game-info-big-text-right {\n    color: #002129;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: 1.0 !important;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    text-align: right;\n}\n\n.sportsbook-game-info-small-text {\n    color: #002129;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 10px !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: 1.0 !important;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    text-align: left;\n}\n\n.sportsbook-game-info-small-text-right {\n    color: #002129;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 10px !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: 1.0 !important;\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    text-align: right;\n    margin-top: 10px !important;\n}\n\n.sportsbook-game-info-right-side {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;  // Right align the content\n    margin-right: 10px;\n}\n\n.sportsbook-game-info-right-text {\n    text-align: right;  // Ensure text within the box is right-aligned\n}\n\n//Spacer between the game info and the wager boxes\n.spacer {\n    height: 16px;\n  }\n\n  // Wager Boxes Container  \n \n.sportsbook-wager-boxes-container {\n    width: 100%;\n    margin: 0px 19px;\n    height: 40px;\n    margin-bottom: 11px;\n    display: flex;\n    justify-content: center;\n    gap: 28px; /* Default gap for small screens */\n  }\n  \n  /* Medium screens (md) */\n  @media (min-width: 600px) {\n    .sportsbook-wager-boxes-container {\n      gap: 80px;\n    }\n  }\n  \n  /* Large screens (lg) and up */\n  @media (min-width: 960px) {\n    .sportsbook-wager-boxes-container {\n      gap: 50px;\n    }\n  }\n  \n\n  .sportsbook-wager-box {\n    width: 150px;\n    height: 40px;\n    border: 1px solid #002129;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n  \n    &.sportsbook-wager-box-exceeded {\n      border-color: #CC293C; // Border color for exceeded state\n    }\n  }\n  \n  .sportsbook-wager-box-label {\n    color: #002129;\n    font-size: 10px !important;\n    font-weight: 500 !important;\n    text-align: left;\n    margin-left: 5px !important;\n  \n    &.sportsbook-wager-box-label-exceeded {\n      color: #CC293C; // Text color for exceeded state\n    }\n  }\n  \n  \n  .sportsbook-wager-currency {\n    color: #002129;\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    margin-left: 5px !important;\n    line-height: normal;\n    padding: 0;\n    display: flex;\n    align-items: center;\n  }\n  \n  .sportsbook-wager-input {\n    input {\n      text-align: left; // Adjust to 'right' if needed\n      font-size: 16px;\n      color: #002129;\n      padding: 0 2px;\n      margin-left: 5px;\n    }\n    fieldset {\n      border: none;\n    }\n    .MuiOutlinedInput-root {\n      padding: 0;\n      height: 100%;\n    }\n  }\n\n\n  // Remove Container\n  .sportsbook-remove-container {\n    display: flex;\n    align-items: center;\n    justify-content: center; // Center content horizontally\n    padding: 8px;\n    border: 1px solid #002129;\n    background-color: #fff;\n  }\n  \n  .sportsbook-remove-icon {\n    cursor: pointer;\n  }\n  \n  .sportsbook-remove-text {\n    color: #CC293C;\n    font-weight: 700 !important;\n    margin-left: 16px !important;\n    cursor: pointer;\n    font-size: 14px !important;\n  }\n  \n\n  // Parlay/Teaser Info Container\n  .sportsbook-parlay-teaser-box {\n    width: 100%;\n    height: 43px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center; // Vertically center the text\n    align-items: center; // Horizontally center the text\n    text-align: center; // Center align the text\n    margin-bottom: 8px;\n    background-color: #fff;\n  \n    .sportsbook-parlay-teaser-line1, .sportsbook-parlay-teaser-line2 {\n      color: #002129;\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Inter', sans-serif !important;\n      font-style: normal;\n      text-transform: capitalize;\n      letter-spacing: 0.46px;\n    }\n  \n    .sportsbook-parlay-teaser-line1{\n      font-size: 12px !important;\n      font-weight: 700 !important;\n      line-height: 22px; /* 183.333% */\n    }\n  \n    .sportsbook-parlay-teaser-line2 {\n      font-size: 16px !important;\n      font-weight: 700 !important;\n      line-height: 22px;\n    }\n  }\n\n\n    // Submit Button Container\n    .sportsbook-submit-button-container {\n        height: 58px;\n        display: flex;\n        align-items: center;\n        justify-content: center; // Center the button horizontally\n        border-right: 1px solid #002129;\n        border-left: 1px solid #002129;\n        border-bottom: 1px solid #002129;\n        background-color: #fff;\n      }\n      \n      .sportsbook-submit-button {\n        width: 300px;\n        height: 42px;\n        border: none;\n        border-radius: 4px; // Optional: Add some border radius for rounded corners\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 4px; // Space between the top and bottom text\n        cursor: pointer;\n        background-color: rgba(0, 0, 0, 0.12); // Default background color (will be overridden by active/inactive states)\n      \n        // Maintain the button's appearance on hover\n        &:hover {\n            background-color: currentColor; // Matches button's current color\n            color: currentColor; // Matches button's current text color\n          }\n      \n        &.active {\n          background-color: #00AAD1; // Active background color\n\n          &:hover {\n            background-color: #00AAD1; // Matches button's current color\n          }\n        }\n      \n        &.inactive {\n          background-color: rgba(0, 0, 0, 0.12); // Inactive background color\n\n          &:hover {\n            background-color: rgba(0, 0, 0, 0.12); // Matches button's current color\n          }\n        }\n      }\n      \n      .sportsbook-submit-button-text-top {\n        color: var(--primary-contrast, #FFF);\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: 'Inter', sans-serif;\n        font-size: 20px !important;\n        font-style: normal;\n        font-weight: 700 !important;\n        line-height: 13px; /* 65% */\n        letter-spacing: 0.46px;\n        text-transform: uppercase;\n        text-align: center; // Center text horizontally\n        margin-top: 2px;\n        white-space: nowrap; // Prevent text from wrapping\n      \n        .inactive & {\n          color: rgba(0, 0, 0, 0.38); // Inactive text color\n        }\n      }\n      \n      .sportsbook-submit-button-text-bottom {\n        color: var(--primary-contrast, #FFF);\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: 'Inter', sans-serif !important;\n        font-size: 10px !important;\n        font-style: normal;\n        font-weight: 700 !important;\n        line-height: 13px;\n        letter-spacing: 0.46px;\n        text-transform: uppercase;\n        text-align: center; // Center text horizontally\n      \n        .inactive & {\n          color: rgba(0, 0, 0, 0.38); // Inactive text color\n        }\n      }\n      \n      \n      //Empty Bet Slip Container\n      .sportsbook-bet-unavailable-container {\n        width: 100%; /* 100% width */\n        border-right: 1px solid #002129;\n        border-left: 1px solid #002129;\n        border-bottom: 1px solid #002129;\n        background-color: #fff;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 16px; /* Optional: Add some padding for spacing */\n      }\n      \n      .sportsbook-bet-unavailable-title {\n        color: #002129;\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: 'Inter', sans-serif !important;\n        font-size: 16px !important;\n        font-style: normal;\n        font-weight: 700 !important;\n        line-height: 26px; /* 162.5% */\n        letter-spacing: 0.46px;\n        margin-bottom: 32px !important; /* Optional: Add some margin between the title and the next line */\n      }\n      \n      .sportsbook-bet-unavailable-subtitle, \n      .sportsbook-bet-unavailable-description {\n        color: #002129;\n        text-align: center;\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: 'Inter', sans-serif !important;\n        font-size: 14px !important;\n        font-style: normal;\n        font-weight: 500 !important;\n        line-height: 26px; /* 185.714% */\n        letter-spacing: 0.46px;\n        margin-bottom: 24px !important; /* Optional: Add some margin between lines */\n        max-width: 300px;\n        text-align: center;\n      }\n\n\n      // What Is A Bet Modal\n      .custom-dialog-paper {\n        width: 341px !important; /* Custom width */\n        margin: 0px !important; /* Remove default margin */\n      }\n    \n\n      /* Dialog Header Styling */\n      .dialog-title {\n        color: #000;\n        text-align: center;\n        font-family: Inter, sans-serif !important;\n        font-size: 16px !important;\n        font-weight: 800 !important;\n        line-height: 24px; /* 150% of 16px */\n        letter-spacing: -0.304px;\n      }\n\n      /* Dialog Content Styling */\n      .dialog-content {\n        color: #000;\n        text-align: center;\n        font-family: Inter, sans-serif !important;\n        font-size: 16px !important;\n        font-weight: 500 !important;\n        line-height: 24px; /* 150% of 16px */\n        letter-spacing: -0.304px;\n        white-space: pre-line; /* Preserves line breaks */\n        width: 100% !important; /* Custom width */\n        padding: 10px 16px !important; /* Custom padding */\n      }\n\n      /* Center the Dialog Actions and style the button */\n      .dialog-actions {\n        display: flex;\n        justify-content: center !important;\n        padding: 16px !important;\n\n        .dialog-close-button {\n            color: #fff;\n            background-color: #00AAD1; /* Primary blue color */\n            &:hover {\n                background-color: #00AAD1; /* Darker shade of blue on hover */\n            }\n        }\n      }\n\n\n      // Parlay/Teaser Bet Row Box (for max width and scroll)\n      /* BetSlip.scss */\n\n      .picks-container {\n        max-height: 225px;\n        overflow-y: auto; /* Enable vertical scrolling */\n        width: 100%; /* Ensure it takes up the full width of the parent */\n        box-sizing: border-box; /* Make sure the border is included in the width calculation */\n        margin: 0; /* Remove any default margin */\n      }\n\n\n\n      "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
